module.exports = __webpack_public_path__ + "img/4.940f5488.jpg";